import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const dividerStyles: AbgSxProps = {
  borderColor: paletteBase.black,
};

export const textLinkButtonStyles: AbgSxProps = {
  color: paletteBase.black,
  textDecoration: 'underline',
  padding: 0,
  minWidth: 'unset',
  '&:hover': {
    background: 'none',
    textDecoration: 'underline',
  },
};
